import { Row } from '@/components/layout/layout'
import React, { useMemo, useState } from 'react'
import './data-date-select.scss'
import classnames from 'classnames'
import useBemClass from '@/utils/hooks/useBEMClass'
import dayjs from 'dayjs'
import { useUpdateEffect } from 'ahooks'

export type ScopeType = 'date' | 'week' | 'month' | 'year'

interface DataDateSelectProps {
    class?: string
    onClick: (from: string, to: string, index: number, tip: string) => void
    day?: number
    week?: number
    month?: number
    year?: number
    type?: 'data' | 'trend'
    types?: ScopeType[]
}

export const scopeTypeMap: ScopeType[] = ['date', 'week', 'month', 'year']

const DEFAULT_TYPES: ScopeType[] = ['date', 'week', 'month', 'year']

const DataDateSelect: React.FC<DataDateSelectProps> = props => {
    const cls = useBemClass('data-date-select')
    const [scope, setScope] = useState<number>(0)
    const types = props.types || DEFAULT_TYPES

    const scopeMap = useMemo(() => {
        const labelMap: Record<ScopeType, string> =
            props.type === 'data'
                ? { date: '日数据', week: '周数据', month: '月数据', year: '年数据' }
                : { date: '日走势', week: '周走势', month: '月走势', year: '年走势' }

        return types.map(t => labelMap[t])
    }, [props.type, types])

    useUpdateEffect(() => {
        let fromDate: string | undefined = ''
        let toDate: string | undefined = ''
        let tip = ''
        const formatNum = (num?: number) => (num ? '近' + (num + 1) : '当')
        const type = types[scope]
        if (type === 'date') {
            fromDate = dayjs()
                .subtract(props.day as number, 'day')
                .format('YYYY-MM-DD')
            toDate = dayjs().format('YYYY-MM-DD')
            tip = `当前展示${formatNum(props.day)}${scopeMap[scope]}`
        } else if (type === 'week') {
            fromDate = dayjs()
                .startOf('week')
                .subtract(props.week as number, 'week')
                .add(1, 'd')
                .format('YYYY-MM-DD')
            toDate = dayjs().endOf('week').add(1, 'd').format('YYYY-MM-DD')
            tip = `当前展示${formatNum(props.week)}${scopeMap[scope]}`
        } else if (type === 'month') {
            fromDate = dayjs()
                .startOf('month')
                .subtract(props.month as number, 'month')
                .format('YYYY-MM-DD')
            toDate = dayjs().endOf('month').format('YYYY-MM-DD')
            tip = `当前展示${formatNum(props.month)}${scopeMap[scope]}`
        } else if (type === 'year') {
            fromDate = dayjs()
                .startOf('year')
                .subtract(props.year as number, 'year')
                .format('YYYY-MM-DD')
            toDate = dayjs().endOf('year').format('YYYY-MM-DD')
            tip = `当前展示${formatNum(props.year)}${scopeMap[scope]}`
        }

        props.onClick(fromDate, toDate, scope, tip)
    }, [scope, types])

    return (
        <Row>
            {scopeMap.map((s, index) => (
                <div
                    className={classnames(cls('tab'), {
                        [cls('tab-active')]: index === scope,
                    })}
                    key={s}
                    onClick={() => {
                        setScope(index)
                    }}
                >
                    {s}
                </div>
            ))}
        </Row>
    )
}

DataDateSelect.defaultProps = {
    day: 14,
    week: 7,
    month: 5,
    year: 2,
}

export default DataDateSelect
